<template>
    <div id="notifications-template">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Partnership Owner',
                    to: { path: '/partnership-owner' },
                },
                {
                    text: form.id
                        ? 'Ubah Partnership Owner'
                        : 'Tambah Partnership Owner',
                },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{
                form.id ? "Ubah Partnership Owner" : "Tambah Partnership Owner"
            }}
        </h3>

        <v-form ref="form">
            <v-card flat>
                <v-card-title>
                    {{
                        form.id
                            ? "Ubah Partnership Owner"
                            : "Tambah Partnership Owner"
                    }}
                    <v-spacer></v-spacer>

                    <v-btn
                        depressed
                        rouded
                        small
                        class="pa-2"
                        height="33px"
                        color="#EC675E"
                        style="min-width: 0 !important"
                    >
                        <v-icon color="white" style="font-size: 20px">
                            mdi-delete-outline
                        </v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider />
                <v-card-text>
                    <template>
                        <div class="mb-2 mt-4">
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Nama Partnership Owner *
                                    </v-list-item-title>

                                    <v-text-field
                                        placeholder="Nama Partnership Owner"
                                        v-model="form.nama"
                                        outlined
                                        :rules="[
                                            (v) =>
                                                !!v ||
                                                'Nama partnership owner wajib diisi',
                                        ]"
                                    />
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Pimpinan *
                                    </v-list-item-title>

                                    <v-text-field
                                        placeholder="Pimpinan"
                                        v-model="form.pimpinan"
                                        outlined
                                        :rules="[
                                            (v) =>
                                                !!v || 'Pimpinan wajib diisi',
                                        ]"
                                    />
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Provinsi *
                                    </v-list-item-title>

                                    <v-autocomplete
                                        placeholder="Pilih Provinsi"
                                        outlined
                                        class="pa-0"
                                        v-model="form.provinsi"
                                        :items="data_provinsi"
                                        :rules="[
                                            (v) =>
                                                !!v || 'Provinsi wajib diisi',
                                        ]"
                                        item-text="nama_provinsi"
                                        item-value="kode_provinsi"
                                    ></v-autocomplete>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Alamat *
                                    </v-list-item-title>

                                    <v-text-field
                                        placeholder="Alamat"
                                        v-model="form.alamat"
                                        outlined
                                        :rules="[
                                            (v) => !!v || 'Alamat wajib diisi',
                                        ]"
                                    />
                                </v-list-item-content>
                            </v-list-item>

                            <!-- <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                  <v-list-item-title class="font-weight-bold pb-2">
                    Identitas Owner *
                  </v-list-item-title>

                  <v-text-field
                    placeholder="Identitas Owner"
                    v-model="form.identitas_owner"
                    outlined
                    :rules="[(v) => !!v || 'Identitas Owner wajib diisi']"
                  />
                </v-list-item-content>
              </v-list-item> -->

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Deskripsi *
                                    </v-list-item-title>

                                    <v-text-field
                                        placeholder="Deskripsi"
                                        v-model="form.description"
                                        outlined
                                        maxlength="255"
                                        :rules="[
                                            (v) =>
                                                !!v || 'Deskripsi wajib diisi',
                                        ]"
                                    />
                                </v-list-item-content>
                            </v-list-item>
                        </div>
                        <v-row class="pa-4">
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                @click="$router.push('/partnership-owner')"
                                class="mr-2"
                            >
                                Batal
                            </v-btn>
                            <v-btn
                                color="primary"
                                depressed
                                @click="submitProcess()"
                            >
                                Simpan
                            </v-btn>
                        </v-row>
                    </template>
                </v-card-text>
            </v-card>
        </v-form>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import axios from "axios";

export default {
    name: "notifications-template",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            token: JSON.parse(localStorage.getItem("token")).value,
            isLoading: false,
            data: [],
            page: "form",
            form: {
                nama: null,
                pimpinan: null,
                identitas_owner: null,
                alamat: null,
                negara: null,
                provinsi: null,
                kota: null,
                kecamatan: null,
                kelurahan: null,
                pimpinan: null,
                no_fax: null,
                email: null,
                web: null,
                fb: null,
                twitter: null,
                linkedin: null,
                no_telp: null,
                deskripsi: null,
            },
            data_provinsi: null,
        };
    },

    watch: {},

    created() {
        this.getDataProvince();
    },

    mounted: function () {
        this.fetchData();
    },

    methods: {
        fetchData() {
            const context = this;
            const id = this.$route.query.id;
            const url = `${process.env.API_BASE_URL}partnership/admin/owner/detail/${id}`;

            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.form = response.data;
                    context.form.provinsi =
                        response.data.partner_provinsi.kode_provinsi;
                }
            });
        },
        getDataProvince() {
            const context = this;
            const url = `${process.env.API_BASE_URL}partnership/region/list-provinsi`;

            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.data_provinsi = response.data;
                }
            });
        },
        submitProcess() {
            const context = this;
            const id = this.$route.query.id;
            var url = "";

            if (id) {
                url = `${process.env.API_BASE_URL}partnership/admin/owner/${id}`;
            } else {
                url = `${process.env.API_BASE_URL}partnership/admin/owner/register`;
            }

            const authToken = this.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            if (context.$refs.form.validate()) {
                if (!id) {
                    try {
                        axios
                            .post(url, context.form, options)
                            .then(function (response) {
                                if (response.status === 200) {
                                    context.$store.commit("showAlert", {
                                        message: `Berhasil menambahkan partnership owner`,
                                        type: "success",
                                    });

                                    context.$router.push("/partnership-owner");
                                } else {
                                    context.$store.commit("showAlert", {
                                        message: `Terjadi Kesalahan`,
                                        submessage: `Tidak dapat menambahkan partnership owner untuk saat ini`,
                                        type: "error",
                                    });
                                }
                            });
                    } catch (err) {
                        context.$store.commit("showAlert", {
                            message: `Terjadi Kesalahan`,
                            submessage: `Tidak dapat menambahkan partnership owner untuk saat ini`,
                            type: "error",
                        });
                    }
                } else {
                    try {
                        axios
                            .put(url, context.form, options)
                            .then(function (response) {
                                if (response.status === 200) {
                                    context.$store.commit("showAlert", {
                                        message: `Berhasil mengubah partnership owner`,
                                        type: "success",
                                    });

                                    context.$router.push("/partnership-owner");
                                } else {
                                    context.$store.commit("showAlert", {
                                        message: `Terjadi Kesalahan`,
                                        submessage: `Tidak dapat mengubah partnership owner untuk saat ini`,
                                        type: "error",
                                    });
                                }
                            });
                    } catch (err) {
                        context.$store.commit("showAlert", {
                            message: `Terjadi Kesalahan`,
                            submessage: `Tidak dapat mengubah partnership owner untuk saat ini`,
                            type: "error",
                        });
                    }
                }
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// PartnershipOwnerForm.vue?84fae0c2